import palette from './palette';

export default {
  useNextVariants: true,
  h1: {
    fontSize: '2.2em',
    lineHeight: '1.8em',
    color: palette.text.primary,
  },
  h2: {
    fontSize: '2em',
    lineHeight: '1.5em',
    color: palette.text.primary,
  },
  h3: {
    fontSize: '1.5em',
    lineHeight: '1.5em',
    color: palette.text.primary,
  },
};
